import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import English translations
import enCommon from './Translations/en/common.json';
import enSidebar from './Translations/en/sidebar.json';
import enHeader from './Translations/en/header.json';
import enHome from './Translations/en/home.json';
import enGlobalSettings from './Translations/en/globalSettings.json';
import enEntities from './Translations/en/entities.json';
import enGroups from './Translations/en/groups.json';
import enQueues from './Translations/en/queues.json';
import enCallFlows from './Translations/en/callFlows.json';
import enIaAgent from './Translations/en/iaAgent.json';
import enChatFlows from './Translations/en/chatFlows.json';
import enAgents from './Translations/en/agents.json';
import enRecordings from './Translations/en/recordings.json';
import enAnalytics from './Translations/en/analytics.json';
import enLicences from './Translations/en/licences.json';
import enMedia from './Translations/en/media.json';
import enRealtime from './Translations/en/realtime.json';
import enVariables from './Translations/en/variables.json';
import enWorkflows from './Translations/en/workflows.json';
import enGlobalSettingsInfo from './Translations/en/dataInfo/globalSettingsInfo.json';
import enQueuesInfo from './Translations/en/dataInfo/queuesInfo.json';
import enAgentsInfo from './Translations/en/dataInfo/agentsInfo.json';
import enRecordingsInfo from './Translations/en/dataInfo/recordingsInfo.json';
import enLicencesInfo from './Translations/en/dataInfo/licencesInfo.json';
import enCallFlowsInfo from './Translations/en/dataInfo/callFlowsInfo.json';
import enChatFlowsInfo from './Translations/en/dataInfo/chatFlowsInfo.json';
import enAnalyticsInfo from './Translations/en/dataInfo/analyticsInfo.json';

// Import French translations
import frCommon from './Translations/fr/common.json';
import frSidebar from './Translations/fr/sidebar.json';
import frHeader from './Translations/fr/header.json';
import frHome from './Translations/fr/home.json';
import frGlobalSettings from './Translations/fr/globalSettings.json';
import frEntities from './Translations/fr/entities.json';
import frGroups from './Translations/fr/groups.json';
import frQueues from './Translations/fr/queues.json';
import frCallFlows from './Translations/fr/callFlows.json';
import frIaAgent from './Translations/fr/iaAgent.json';
import frChatFlows from './Translations/fr/chatFlows.json';
import frAgents from './Translations/fr/agents.json';
import frRecordings from './Translations/fr/recordings.json';
import frAnalytics from './Translations/fr/analytics.json';
import frLicences from './Translations/fr/licences.json';
import frMedia from './Translations/fr/media.json';
import frRealtime from './Translations/fr/realtime.json';
import frVariables from './Translations/fr/variables.json';
import frWorkflows from './Translations/fr/workflows.json';
import frGlobalSettingsInfo from './Translations/fr/dataInfo/globalSettingsInfo.json';
import frQueuesInfo from './Translations/fr/dataInfo/queuesInfo.json';
import frAgentsInfo from './Translations/fr/dataInfo/agentsInfo.json';
import frRecordingsInfo from './Translations/fr/dataInfo/recordingsInfo.json';
import frLicencesInfo from './Translations/fr/dataInfo/licencesInfo.json';
import frCallFlowsInfo from './Translations/fr/dataInfo/callFlowsInfo.json';
import frChatFlowsInfo from './Translations/fr/dataInfo/chatFlowsInfo.json';
import frAnalyticsInfo from './Translations/fr/dataInfo/analyticsInfo.json';

// Merge all English translations
const en = {
  ...enCommon,
  ...enSidebar,
  ...enHeader,
  ...enHome,
  ...enGlobalSettings,
  ...enEntities,
  ...enGroups,
  ...enQueues,
  ...enCallFlows,
  ...enIaAgent,
  ...enChatFlows,
  ...enAgents,
  ...enRecordings,
  ...enAnalytics,
  ...enLicences,
  ...enMedia,
  REALTIME: enRealtime,
  ...enVariables,
  ...enWorkflows,
  INFO: {
    GLOBAL_SETTINGS: enGlobalSettingsInfo,
    QUEUES: enQueuesInfo,
    AGENTS: enAgentsInfo,
    RECORDINGS: enRecordingsInfo,
    LICENCES: enLicencesInfo,
    CALL_FLOWS: enCallFlowsInfo,
    CHAT_FLOWS: enChatFlowsInfo,
    ANALYTICS: enAnalyticsInfo
  }
};

// Merge all French translations
const fr = {
  ...frCommon,
  ...frSidebar,
  ...frHeader,
  ...frHome,
  ...frGlobalSettings,
  ...frEntities,
  ...frGroups,
  ...frQueues,
  ...frCallFlows,
  ...frIaAgent,
  ...frChatFlows,
  ...frAgents,
  ...frRecordings,
  ...frAnalytics,
  ...frLicences,
  ...frMedia,
  REALTIME: frRealtime,
  ...frVariables,
  ...frWorkflows,
  INFO: {
    GLOBAL_SETTINGS: frGlobalSettingsInfo,
    QUEUES: frQueuesInfo,
    AGENTS: frAgentsInfo,
    RECORDINGS: frRecordingsInfo,
    LICENCES: frLicencesInfo,
    CALL_FLOWS: frCallFlowsInfo,
    CHAT_FLOWS: frChatFlowsInfo,
    ANALYTICS: frAnalyticsInfo
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    lng: navigator.language.split('-')[0], // Détecte la langue du navigateur
    fallbackLng: 'en', // Langue par défaut
    interpolation: {
      escapeValue: false, // React gère la protection XSS
    },
  });

export default i18n;
